/**
 * Used to derive link from href
 * @property {String} type - determines if link is for helpset topic, download or filepub "HT | DL | FP"
 * @property {ISOLangCode} langCode -  the itemLang language
 * @property {String} itemExtId - item identifier
 * @property {String} subItemType - KbX | KbB | Kbff  // Xml, Binary, folder file (deprecated)
 * @property {String} subItemId  - topicSourceId
 */

export default class KbParser {
  href = "";
  kbrid = "";
  type = "";
  langCode = "";
  itemExtId = "";
  subItemType;
  subItemId;
  fragmentId = "";
  item;

  constructor(item) {
    this.item = item;
  }

  static isKbrid(href) {
    let tildeCount = (href.match(/~/g)||[]).length
    return !href.includes("//") && tildeCount>=2;
  }

  setHref(href) {
    this.href = href;
  }

  getKbrid() {
    return this.kbrid;
  }

  getItem() {
    return this.item;
  }

  async _fecthItem() {
    try {
      let response = await fetch(
        `/kb/jrest/getTree?externalId=${this.itemExtId}&langCode=${this.langCode}`
      );
      if (!response.ok) {
        throw Error("Bad response");
      }
      this.item = await response.json();
    } catch (e) {
      console.log(e);
    }
  }

  _getKbridParameters() {
    [this.kbrid, this.fragmentId] = this.href.split("~Fxd");
    [
      this.type,
      this.langCode,
      this.itemExtId,
      this.subItemType,
      this.subItemId,
    ] = this.kbrid.split("~");
  }

  _generateLinkFromKbrid() {
    switch (this.type) {
      case "DHT":
        return `/kb/${this.langCode}/${this.itemExtId}/${this.kbrid}`;
      case "HT":
        return `/kb/${this.langCode}/${this.itemExtId}/${this.kbrid}${
          this.fragmentId ? `#${this.fragmentId}` : ""
        }`;
      case "DL":
        return `/kb/${this.langCode}/${this.itemExtId}/${this.kbrid}`;
      case "FP":
        return `/kb/${this.langCode}/${this.itemExtId}`;
      case "SC":
        return `/kb/${this.langCode}/${this.itemExtId}`;
    }
  }

  parse() {
    if (KbParser.isKbrid(this.href)) {
      this._getKbridParameters(this.href);
      return this._generateLinkFromKbrid();
    }
  }

  isIPC() {
    return this.item?.itemLang?.flags === 1;
  }
}
